import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/(auth)/login/page.tsx");
